import * as common from '@/store/common/mutation-types';
export const SEARCH_PARAM = 'SEARCH_PARAM';
export const STATE_INIT = 'STATE_INIT';
export const DEFAULT_ASSIGN = 'DEFAULT_ASSIGN';
export const PAGING_INFO = 'PAGING_INFO';
export const SELECTED_ROW = 'SELECTED_ROW';
export const EXCEL_POUPUP_PARAM = 'EXCEL_POUPUP_PARAM';
export const SELECTED_ROW_INIT = 'SELECTED_ROW_INIT';

export default {
	...common,
	SEARCH_PARAM,
	STATE_INIT,
	DEFAULT_ASSIGN,
	PAGING_INFO,
	EXCEL_POUPUP_PARAM,
	SELECTED_ROW_INIT,
	SELECTED_ROW
};
